import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { ActionSearch } from "../../../../store/slices/search/actions";
import { TITLE_TEXT } from "../../utils/constants";
import { HeaderSearch } from "./HeaderSearch";
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    title: TITLE_TEXT,
    onClick: function onClick() {
      return dispatch(ActionSearch.toggleOpenSidebar(false));
    }
  };
};
export var HeaderSearchRC = compose(connect(null, mapDispatchToProps), withRenderFlag)(HeaderSearch);